import React, { useEffect, useRef } from 'react';
import Button from '../../../components/ui/Button';


const HeroSection = () => {
  const mockupRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (mockupRef?.current) {
        const scrollY = window.scrollY;
        const translateY = scrollY * 0.3;
        const scale = 1 + scrollY * 0.0002;
        mockupRef.current.style.transform = `translateY(${translateY}px) scale(${Math.min(scale, 1.1)})`;
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleDemoClick = () => {
    const demoSection = document.getElementById('demo');
    if (demoSection) {
      const offset = 80;
      const elementPosition = demoSection?.offsetTop - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section id="platform" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-16 sm:pt-20 px-4">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-background to-background z-0" />
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 sm:w-96 sm:h-96 bg-primary/10 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 sm:w-96 sm:h-96 bg-accent/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full">
        <div className="text-center mb-8 sm:mb-12 animate-fade-in">
          <div className="inline-flex items-center space-x-2 glassmorphism px-3 sm:px-4 py-1.5 sm:py-2 rounded-full mb-4 sm:mb-6">
            <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-primary rounded-full animate-pulse" />
            <span className="text-xs sm:text-sm font-medium text-muted-foreground">Новое поколение CRM-систем</span>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black text-foreground mb-4 sm:mb-6 leading-tight px-2">
            Единая CRM-платформа<br />
            <span className="bg-gradient-to-r from-primary via-accent to-secondary bg-clip-text text-transparent">
              нового поколения
            </span>
            <br />с ИИ-автоматизацией
          </h1>

          <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-muted-foreground mb-6 sm:mb-8 max-w-3xl mx-auto px-4">
            Замените 5+ разрозненных систем одной платформой СФЕРА
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-8 sm:mb-12 px-4">
            <Button
              variant="default"
              size="xl"
              onClick={handleDemoClick}
              iconName="Calendar"
              iconPosition="left"
              className="neon-glow-primary shadow-cta w-full sm:w-auto"
            >
              Получить демо
            </Button>
            <Button
              variant="outline"
              size="xl"
              iconName="Play"
              iconPosition="left"
              className="w-full sm:w-auto"
            >
              Смотреть обзор
            </Button>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 md:gap-8 text-xs sm:text-sm text-muted-foreground px-4">
            <div className="flex items-center space-x-2">
              <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-primary/10 flex items-center justify-center">
                <span className="text-primary font-bold text-xs sm:text-sm">500+</span>
              </div>
              <span className="text-xs sm:text-sm">Компаний используют</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-accent/10 flex items-center justify-center">
                <span className="text-accent font-bold text-xs sm:text-sm">10K+</span>
              </div>
              <span className="text-xs sm:text-sm">Лидов в день</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-secondary/10 flex items-center justify-center">
                <span className="text-secondary font-bold text-xs sm:text-sm">40%</span>
              </div>
              <span className="text-xs sm:text-sm">Рост продаж</span>
            </div>
          </div>
        </div>

        <div ref={mockupRef} className="relative max-w-6xl mx-auto transition-transform duration-100 px-2 sm:px-0">
          <div className="glassmorphism-strong rounded-lg sm:rounded-2xl overflow-hidden shadow-glass border border-primary/20 sm:border-2">
            <div className="flex items-center space-x-2 px-3 sm:px-4 py-2 sm:py-3 border-b border-border">
              <div className="flex space-x-1.5 sm:space-x-2">
                <div className="w-2 h-2 sm:w-3 sm:h-3 rounded-full bg-error" />
                <div className="w-2 h-2 sm:w-3 sm:h-3 rounded-full bg-warning" />
                <div className="w-2 h-2 sm:w-3 sm:h-3 rounded-full bg-success" />
              </div>
              <div className="flex-1 text-center">
                <span className="text-[10px] sm:text-xs text-muted-foreground font-mono">crm.sfera.ru</span>
              </div>
            </div>
            
            <div className="aspect-video bg-gradient-to-br from-card via-background to-card p-2 sm:p-4">
              <div className="grid grid-cols-12 gap-2 sm:gap-4 h-full">
                <div className="col-span-3 sm:col-span-2 glassmorphism rounded p-2 sm:p-3 space-y-1.5 sm:space-y-2">
                  <div className="h-6 sm:h-8 bg-primary/20 rounded" />
                  <div className="h-4 sm:h-6 bg-muted/50 rounded" />
                  <div className="h-4 sm:h-6 bg-muted/50 rounded" />
                  <div className="h-4 sm:h-6 bg-muted/50 rounded hidden sm:block" />
                  <div className="h-4 sm:h-6 bg-muted/50 rounded hidden sm:block" />
                </div>
                
                <div className="col-span-9 sm:col-span-7 space-y-2 sm:space-y-3">
                  <div className="glassmorphism rounded p-2 sm:p-4">
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3">
                      {[1, 2, 3, 4]?.map((i) => (
                        <div key={i} className={`glassmorphism rounded p-2 sm:p-3 space-y-1.5 sm:space-y-2 ${i > 2 ? 'hidden sm:block' : ''}`}>
                          <div className="h-3 sm:h-4 bg-primary/30 rounded" />
                          <div className="h-6 sm:h-8 bg-accent/20 rounded" />
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="glassmorphism rounded p-2 sm:p-4 space-y-1.5 sm:space-y-2">
                    {[1, 2, 3, 4]?.map((i) => (
                      <div key={i} className={`flex items-center space-x-2 sm:space-x-3 p-1.5 sm:p-2 hover:bg-muted/20 rounded transition-colors ${i > 2 ? 'hidden sm:flex' : ''}`}>
                        <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-gradient-to-br from-primary to-accent flex-shrink-0" />
                        <div className="flex-1 space-y-1 min-w-0">
                          <div className="h-2 sm:h-3 bg-muted/50 rounded w-3/4" />
                          <div className="h-1.5 sm:h-2 bg-muted/30 rounded w-1/2" />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="hidden lg:block col-span-3 glassmorphism rounded-lg p-3 space-y-3">
                  <div className="flex items-center space-x-2 pb-2 border-b border-border">
                    <div className="w-8 h-8 rounded-full bg-gradient-to-br from-secondary to-primary" />
                    <div className="flex-1">
                      <div className="h-3 bg-muted/50 rounded mb-1" />
                      <div className="h-2 bg-success/50 rounded w-16" />
                    </div>
                  </div>
                  {[1, 2, 3]?.map((i) => (
                    <div key={i} className="glassmorphism rounded p-2 space-y-1">
                      <div className="h-2 bg-muted/50 rounded" />
                      <div className="h-2 bg-muted/30 rounded w-3/4" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;